import { HpDispatchFunction } from '../types';
import { HpNavigationChangedPayload } from './navigationChangedActionTypes';

export function navigationChangedAction(payload: HpNavigationChangedPayload) {
  return (dispatch: HpDispatchFunction<HpNavigationChangedPayload>): void => {
    dispatch({ type: 'NAVIGATION_CHANGED', payload });
  };
}
